<script>
  import LineruTagsService from "../services/lineru-tags";
  import GoogleTagManagerService from "../services/tag-manager";


  function navigateTo(idTarget) {
    const target = document.getElementById(idTarget) || document.body;
    const topPos = target.getBoundingClientRect().top + window.pageYOffset - 0;
    GoogleTagManagerService.setTag(LineruTagsService.general().toRefer);

    scroll({
      top: topPos,
      behavior: "smooth",
    });
  }
</script>

<div
  class="bgr-pink-light-1"
  style="background-image: url('images/fold-1/bg-fold-1.png')"
>
  <div class="container pt-8">
    <div class="d-grid grid-12 gap-5">
      <div class="col-12 col-lg-6 pt-20 pb-16">
        <img
          class="mb-5"
          width="128px"
          height="41px"
          src="images/fold-1/logo.svg"
          alt="Lineru"
        />
        <h1 class="mb-8 pt-5">
          Comparte Lineru:
          <br />
          Tus referidos son dinero
        </h1>
        <div class="d-grid grid-4">
          <p class="col-4 t-size-5 mb-8">
            Con cada referido aprobado ganas puntos y puedes cambiarlos por
            aumentos de cupo. O por descuentos para pagar menos en tus
            desembolsos.
          </p>
        </div>
        <div class="col-12">
          <button
            class="btn btn--shadow bgr-primary-500 bgr-brand-2:active t-white btn-lg mb-6 w-100 w-lg-auto d-flex t-left align-items-center"
            on:click={() => navigateTo("fold-2")}
            role="button"
            aria-labelledby=""
          >
            <span class="flex-grow">Quiero referir</span>
            <svg class="ml-3 -mr-3 t-yellow" width="16" height="11"
              ><path
                fill="currentColor"
                d="M15.902 5.257l-5-5.156a.326.326 0 00-.471 0 .351.351 0 000 .486l4.431 4.57H.333A.338.338 0 000 5.5c0 .19.15.344.333.344h14.529l-4.431 4.57a.351.351 0 000 .485.327.327 0 00.471 0l5-5.156a.351.351 0 000-.486z"
              /></svg
            > <span class="d-none qwerty" />
          </button>
        </div>
      </div>
      <div class="col-lg-6 align-self-end d-none d-lg-block">
        <div class="d-grid">
          <div class="col-start-1">
            <img class="d-block" src="images/fold-1/models.png" alt="Lineru" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
